import {
  Analysis,
  DashboardConfigurationDependencies,
  Granularity,
} from '../../../../dashboard-config/dashboard-config.model';
import { DashboardFilter } from '../../../../filters/dashboard_filter';
import { GRANULARITY_PROFILES } from '../../../../dashboard-config/granularities/granularity-profile';
import { composeHeading } from '../../../_shared/dashboard-axes';
import {
  DashboardIndustriesMultiSelectFilter,
  DashboardStateSingleSelectFilter,
} from '../../../../filters/dashboard_filter_implementations';
import { ComparisonIndustriesMetricProfile } from './dashboard-comparison-industries-metric.profile';
import { DashboardComparisonIndustriesView } from './dashboard-comparison-industries.definition';

export const COMPARISON_INDUSTRIES_SHELL_ID = 'comparison-industries' as const;

export type DashboardComparisonIndustriesShell = 'industries';

export type DashboardComparisonIndustriesViewDefaults = Pick<
  DashboardComparisonIndustriesView,
  'showPercentageChange'
>;

export interface DashboardComparisonIndustriesShellProfile {
  id: typeof COMPARISON_INDUSTRIES_SHELL_ID;
  analysisId: Analysis;
  granularityId: Granularity;
  viewDefaults: DashboardComparisonIndustriesViewDefaults;
  buildGranularityFilters: (
    deps: DashboardConfigurationDependencies,
  ) => DashboardFilter<any>[];
  createHeading: (options: {
    metric: ComparisonIndustriesMetricProfile;
  }) => (
    filterValues: Map<string, any>,
    product?: any,
    deps?: DashboardConfigurationDependencies,
  ) => string;
}

export const dashboardComparisonIndustriesShellProfiles: Record<DashboardComparisonIndustriesShell, DashboardComparisonIndustriesShellProfile> = {
  industries: {
    id: COMPARISON_INDUSTRIES_SHELL_ID,
    analysisId: Analysis.Comparison,
    granularityId: Granularity.IndustrySubMarkets,
    viewDefaults: {
      showPercentageChange: false,
    },
    buildGranularityFilters: (deps) => [
      new DashboardStateSingleSelectFilter(deps.localDatasetsService, {}),
      new DashboardIndustriesMultiSelectFilter(deps.localDatasetsService, {}),
    ],
    createHeading:
      ({ metric }) =>
      (filterValues, _product, deps) => {
        const prefix = metric.headingPrefix;
        let sumSubMarketName =
          deps!.localDatasetsService.getSumSubMarketNameByMethodologyId(
            +filterValues.get('methodology'),
          );
        if (metric.stripSumSigmaFromSumSubMarket) {
          sumSubMarketName = sumSubMarketName.replace(/[Σ∑]/g, '');
        }

        const metricPhrase = composeHeading([prefix, metric.headingMetricValue(filterValues)]);

        const byPhrase = GRANULARITY_PROFILES[Granularity.IndustrySubMarkets].byPhrase;
        return `${metricPhrase} DER ${sumSubMarketName} ${byPhrase}, ${filterValues.get('state')}, ${metric.headingTimeValue(filterValues)}`;
      },
  },
};
